module.exports = __webpack_public_path__ + "static/media/autokar3 (5).77582c8c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/img/wynajem/autokar3 (5).jpg
// module id = 862
// module chunks = 0